import React from 'react';
import errorLogo from '../../assets/images/image_404.png';

/**
 * Images qui viennent des la personnalisation des pages
 * @param props props
 * @constructor
 */
export function ImageAdmin(props: { src: string; alt: string; className: string }) {
    //Permet de gérer le cas ou les images sont mal formatées
    //Si l'image n'est pas interprétée correctement alors on affiche un logo par défaut
    return (
        <img
            className={props.className}
            src={props.src}
            alt={props.alt}
            onError={e => {
                e.currentTarget.src = errorLogo;
            }}
        />
    );
}
